import React, { useState, useEffect } from "react";
import { Alert, Col, Container, FormControl, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Typeahead } from "react-bootstrap-typeahead";
import { useLocation, useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "react-bootstrap-typeahead/css/Typeahead.css";
import moment from "moment-timezone";
import Select from "react-select";
import jwt_decode from "jwt-decode";
import PubSub from "pubsub-js";
import solisPowerApi from "../../api/solisPowerApi";
import { formatDate, formatDateTime, formatDateTimeForApi, getFormattedTimestamp, getFormattedTimestampOfDate } from "../../utils/helper";
import { validationMessages } from "../../utils/messages";

// Define initial errors i.e. required field and their message
const initialErrors = {
    title: { message: validationMessages.name.required },
    type: { message: validationMessages.type.required },
    priority: { message: validationMessages.priority.required },
    status: { message: validationMessages.status.required },
    targetdate: { message: validationMessages.date.required },
    owner_id: { message: validationMessages.ownerId.required },
};

const TaskEdit = (props) => {

    // task state
    const [task, setTask] = useState(props.task ? props.task.row : { parentid: props?.parentid });
    //errors state
    const [errors, setErrors] = useState(!props.visitData ? initialErrors : {});

    // Validation state
    const [validated, setValidated] = useState(false);

    // assign users state
    const [assignUsers, setAssignUsers] = useState([]);


    // const [option, setOption] = useState();
    // const [taskTargetDate, setTaskTargetDate] = useState();
    // const [currentTargetDate, setCurrentTargetDate] = useState();

    useEffect(() => {
        async function init() {
            const resultedUsers = await solisPowerApi.fetchUsers();
            (resultedUsers && Array.isArray(resultedUsers))
                ?
                setAssignUsers(resultedUsers.map((user) => ({ value: user.id, label: user.username })))
                :
                setAssignUsers([]);
        }
        init();
    }, []);

    useEffect(() => {
        // let userInfo = jwt_decode(localStorage.getItem('token'));

        // let tempValue = {};
        // tempValue.value = userInfo.id;
        // tempValue.label = userInfo.username;
        // setOption(tempValue);

        // if (props.task) {
        // let temp = {};
        // temp.value = props.task.row.owner_id;
        // temp.label = props.task.row.owner_name;
        // setOption(temp);
        // }

        // if (props.parentid !== null && props.task !== null) {
        //     let current = new Date();
        // task.lastmodifieddate = moment(current).format('YYYY-MM-DD');
        // }

        // setSelectedUser(task.owner_name);
    }, []);



    const handleChange = (e) => {
        // if (e.target.name === "targetdate") {
        //     // Set the date to the start of the day in the Indian time zone (IST)
        //     const selectedDate = getFormattedTimestampOfDate(e.target.value);
        //     setTask({ ...task, targetdate: selectedDate });
        // } else {

        setTask((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        // }
    };

    const checkRequiredFields = () => {
        if (task.targetdate == '') {
            return true;
        }
        if (task.title && task.title.trim() !== '' && task.status && task.status.trim() !== '' && task.priority && task.priority.trim() !== '' && task.owner_id && task.owner_id.trim() !== '') {
            return false;
        }

        return true;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (checkRequiredFields()) {
            setValidated(true);
            return;
        }

        // delete unnecessary fields 
        delete task.owner_name;

        // handle date/datetime fields - use datetime format for targetdate when available
        if (task.targetdate) {
            task.targetdate = formatDateTimeForApi(task.targetdate) || formatDate(task.targetdate);
        }

        if (task.id) {
            const result = await solisPowerApi.saveTask(task);
            if (result) {
                submitTasksData();
                PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Save successfully' });
            }
        } else {
            const result = await solisPowerApi.createTask(task);
            console.log("Create Task API Result", result);
            if (result) {
                PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Save successfully' });
                
                // Updated By System on 2026-04-29 - Event-Based Project Status Update
                if (task.parentid) {
                    try {
                        await solisPowerApi.updateProjectStatusesByLeadId(task.parentid, "Negotiation/ Followup");
                    } catch (err) {
                        console.warn("[TaskEdit] Auto-status update failed:", err);
                    }
                }
                
                submitTasksData();
            }
        }
    };

    const submitTasksData = () => {
        console.log("Props Tasks", props);
        props.submitTasks();
    };

    const handleSaveAndCreateNext = async () => {
        if (checkRequiredFields()) {
            setValidated(true);
            return;
        }
        delete task.owner_name;
        if (task.targetdate) {
            task.targetdate = formatDateTimeForApi(task.targetdate) || formatDate(task.targetdate);
        }
        const payload = { ...task, status: "Completed" };
        const result = await solisPowerApi.saveTask(payload);
        if (result) {
            submitTasksData();
            PubSub.publish("RECORD_SAVED_TOAST", { title: "Record Saved", message: "Task saved successfully" });
            props.onSaveAndCreateNext?.();
        }
    };

    const isEditMode = !!task?.id;
    const isCompleted = (task?.status || "").trim() === "Completed";

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form className="mt-3" noValidate validated={validated} onSubmit={handleSubmit} >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {props?.table === 'lead' ? 'Edit Task' : 'Edit Follow Up'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container className="view-form">
                        <Row>
                            <Col lg={12}>
                                <Row>
                                    {/* <Alert variant="danger" show={show} className="error-alert">
                                        Please Select Assign Staff
                                    </Alert> */}
                                    <Col>
                                        <Form.Group>
                                            <Form.Label
                                                className="form-view-label"
                                                htmlFor="formBasicTitle"
                                            >
                                                {props.table === 'lead' ?
                                                    'Title'
                                                    :
                                                    'Follow Up'
                                                }
                                            </Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                name="title"
                                                placeholder="Enter title"
                                                value={task?.title || ""}
                                                onChange={handleChange}
                                            />
                                            <FormControl.Feedback type="invalid">
                                                {errors?.title?.message}
                                            </FormControl.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label
                                                className="form-view-label"
                                                htmlFor="formBasicType"
                                            >
                                                Type
                                            </Form.Label>
                                            <Form.Select
                                                aria-label="Enter Payment Status"
                                                name="type"
                                                value={task.type || ""}
                                                onChange={handleChange}
                                            >
                                                <option value=''>--Select--</option>
                                                <option value="Call">Call</option>
                                                <option value="Task">Task</option>
                                                <option value="Email">Email</option>
                                                <option value="Meeting">Meeting</option>
                                                <option value="Notes">Notes</option>
                                            </Form.Select>
                                            <FormControl.Feedback type="invalid">
                                                {errors?.type?.message}
                                            </FormControl.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label
                                                className="form-view-label"
                                                htmlFor="formBasicPriority"
                                            >
                                                Priority
                                            </Form.Label>
                                            <Form.Select
                                                required
                                                aria-label="Enter Priority"
                                                name="priority"
                                                value={task.priority || ""}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Priority</option>
                                                <option value="Low">Low</option>
                                                <option value="Normal">Normal</option>
                                                <option value="High">High</option>
                                            </Form.Select>
                                            <FormControl.Feedback type="invalid">
                                                {errors?.priority?.message}
                                            </FormControl.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label
                                                className="form-view-label"
                                                htmlFor="formBasicStatus"
                                            >
                                                Status
                                            </Form.Label>
                                            <Form.Select
                                                required
                                                aria-label="Enter status"
                                                name="status"
                                                value={task.status || ""}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Status</option>
                                                <option value="Pending">Pending</option>
                                                <option value="In Progress">In Progress</option>
                                                <option value="Completed">Completed</option>
                                                <option value="Re-Follow-Up">Re-Follow-up</option>
                                                <option value="Deferred">Deferred</option>
                                            </Form.Select>
                                            <FormControl.Feedback type="invalid">
                                                {errors?.status?.message}
                                            </FormControl.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label
                                                className="form-view-label"
                                                htmlFor="formBasicTargetDate"
                                            >
                                                Target date & Time
                                            </Form.Label>
                                            <Form.Control
                                                required
                                                type="datetime-local"
                                                name="targetdate"
                                                placeholder="Enter target date and time"
                                                value={task.targetdate ? moment(task.targetdate).format("YYYY-MM-DDTHH:mm") : ""}
                                                onChange={handleChange}
                                                onKeyDown={(e) => e.preventDefault()}
                                            />
                                            <FormControl.Feedback type="invalid">
                                                {errors?.targetdate?.message}
                                            </FormControl.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group>
                                            <Form.Label
                                                className="form-view-label"
                                                htmlFor="formBasicOwner"
                                            >
                                                Assign Staff
                                            </Form.Label>
                                            <Select
                                                required
                                                name="owner_id"
                                                className={`${task?.owner_id ? 'custom-select-valid' : 'custom-select-invalid'}`}
                                                onChange={(e) => {
                                                    handleChange({ target: { name: "owner_id", value: e.value } });
                                                    handleChange({ target: { name: "owner_name", value: e.label } });
                                                }}
                                                options={assignUsers}
                                                value={task?.owner_id ? { value: task?.owner_id || "", label: task?.owner_name || "" } : ""}
                                            />
                                            {(errors?.owner_id?.message && (!task.owner_id)) && <div className="feedback-invalid">
                                                {errors?.owner_id?.message}
                                            </div>}
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Group>
                                            <Form.Label
                                                className="form-view-label"
                                                htmlFor="formBasicDescription"
                                            >
                                                Description
                                            </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="description"
                                                placeholder="Enter description"
                                                value={task.description || ""}
                                                onChange={handleChange}
                                            />
                                            <FormControl.Feedback type="invalid">
                                                {errors?.title?.message}
                                            </FormControl.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    {isEditMode && isCompleted && props.onSaveAndCreateNext && (
                        <Button
                            variant="primary"
                            onClick={handleSaveAndCreateNext}
                            className="me-auto"
                        >
                            New Task
                        </Button>
                    )}
                    <Button variant="success" type="submit">Save</Button>
                    <Button onClick={props.onHide} variant="light">Close</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default TaskEdit;
